import OrderInterval from "../symbols/orderInterval";

export interface IState {
  interval: number;
}
const initialState: IState = {
  interval: 0
};

function OrderIntervalReducer(state = initialState, action: any) {
  switch (action.type) {
    case OrderInterval.SET_ORDER_INTERVAL:
      return { ...state, interval: action.payload };
    default:
      return state;
  }
}
export default OrderIntervalReducer;
